module.exports = __webpack_public_path__ + "img/industry2.877c1c04.jpg";